import { render, staticRenderFns } from "./StockTransactionShowData.vue?vue&type=template&id=21e354e7"
import script from "./StockTransactionShowData.vue?vue&type=script&lang=js"
export * from "./StockTransactionShowData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports